<main>
  <ul>
    <li class="title">
      <i
        class="icon-small-back pull-left"
        routerLink="../options"></i>
      {{ "chat.title" | Translate }}
    </li>
  </ul>
  <div class="chat-main">
    <div
      class="chat-main__skeleton"
      *ngIf="isLoading">
      <ngx-skeleton-loader [theme]="{ width: '100%', height: '100%' }"></ngx-skeleton-loader>
    </div>
    <div
      class="chat-main__content"
      *ngIf="!errorKey && iframeURL">
      <iframe
        frameborder="0"
        [src]="iframeURL"
        (error)="iframeError()"
        allow="microphone *; clipboard-write *"
        title="{{ 'chat.title' | Translate }}"></iframe>
    </div>
    <div
      class="chat-main__error"
      *ngIf="errorKey">
      <div class="vox-inline-message vox-inline-message_light-grey">
        <div>
          <i class="icon-small-alert"></i>
          <span>{{ errorKey | Translate }}</span>
        </div>
      </div>
      <button
        *ngIf="isRetryable"
        class="vox-btn vox-btn-secondary"
        (click)="refresh()">
        {{ "chat.refresh" | Translate }}
      </button>
    </div>
  </div>
</main>
